// Prevent redirect to cart after Add to Cart + update cart count bubble
(function () {
  async function getCart() {
    const res = await fetch("/cart.js", {
      headers: { Accept: "application/json" },
      credentials: "same-origin",
    });
    if (!res.ok) throw new Error("Failed to fetch cart");
    return res.json();
  }

  function updateCountBubble(count) {
    // Most Hyper/Fox themes use <cart-count> elements
    document.querySelectorAll("cart-count").forEach((el) => {
      // Some themes read textContent, some read attributes — we update both safely
      el.textContent = `(${count > 99 ? "99+" : count})`;
      el.setAttribute("data-count", String(count));
      if (count > 0) el.removeAttribute("hidden");
      else el.setAttribute("hidden", "");
    });

    // Also update any common fallback selectors
    document
      .querySelectorAll("[data-cart-count], .cart-count, .header__cart-count, .cart-bubble__text")
      .forEach((el) => {
        el.textContent = count > 99 ? "99+" : String(count);
        if (count > 0) el.classList.remove("hidden");
        else el.classList.add("hidden");
      });

    // Update html class if theme uses it
    document.documentElement.classList.toggle("cart-has-items", count > 0);
  }

  document.addEventListener("submit", async function (e) {
    const form = e.target;

    // Only target product add-to-cart forms
    if (!form.matches('form[action*="/cart/add"]')) return;

    e.preventDefault();

    const formData = new FormData(form);

    try {
      const addRes = await fetch("/cart/add.js", {
        method: "POST",
        headers: { Accept: "application/json" },
        body: formData,
        credentials: "same-origin",
      });
      if (!addRes.ok) throw new Error("Add to cart failed");

      // Get fresh cart + update bubble
      const cart = await getCart();
      updateCountBubble(cart.item_count);

      // Tell the theme “cart updated” (many Hyper components listen to this)
      document.dispatchEvent(
        new CustomEvent("cart:updated", {
          detail: { cart },
        })
      );
    } catch (err) {
      console.error(err);
      alert("Could not add to cart. Please try again.");
    }
  });
})();
